/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListTimecardEnforcementSettingsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {ListTimecardEnforcementSettingsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const listTimecardEnforcementSettings = (request: ListTimecardEnforcementSettingsRequest, options?: CashRequestOptions) => post<ListTimecardEnforcementSettingsRequest, ListTimecardEnforcementSettingsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/ListTimecardEnforcementSettings", request, {...options, rejectOnError: true })